import {
  QuoteComparison,
  QuoteDetail,
  QuoteFilter,
  QuoteHeaderPayload,
  QuoteListItem,
  QuoteResult,
  QuoteVersionPayload,
} from "../models/Quote";
import api from "./api";

const failure = (error: any): QuoteResult => ({
  success: false,
  notifications: error?.response?.data?.notifications ?? ["Não foi possível concluir a operação."],
});

const call = async (request: () => Promise<{ data: QuoteResult }>): Promise<QuoteResult> => {
  try {
    return (await request()).data;
  } catch (error) {
    return failure(error);
  }
};

export const getQuotes = async (filter?: QuoteFilter): Promise<QuoteListItem[]> => {
  try {
    const response = await api.get(`/api/quote`, { params: filter });
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const getQuote = async (id: string): Promise<QuoteDetail | undefined> => {
  try {
    const response = await api.get(`/api/quote/${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const createQuote = (data: QuoteHeaderPayload & QuoteVersionPayload & { number: string }) =>
  call(() => api.post(`/api/quote`, data));

export const addQuoteVersion = (id: string, data: QuoteVersionPayload) =>
  call(() => api.post(`/api/quote/${id}/versions`, data));

export const updateQuote = (id: string, data: QuoteHeaderPayload) => call(() => api.put(`/api/quote/${id}`, data));

export const setQuoteStatus = (id: string, status: string, version?: number) =>
  call(() => api.put(`/api/quote/${id}/status`, { status, version }));

export const linkQuoteProcess = (id: string, processId: string | null) =>
  call(() => api.put(`/api/quote/${id}/process`, { processId }));

export const deleteQuote = (id: string) => call(() => api.delete(`/api/quote/${id}`));

/** Estimado (orçamento aprovado) x realizado (DUIMP + numerários) do processo. Undefined = sem acesso. */
export const getQuoteComparison = async (processId: string): Promise<QuoteComparison | undefined> => {
  try {
    const response = await api.get(`/api/quote/process/${processId}/comparison`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};
